// @flow

export function scrollToFirstFieldWithError(attributeBase?: string = 'data-error') {
  const fieldWithError = document.querySelector(`[${attributeBase}]`);
  if (fieldWithError) {
    scrollToElement(fieldWithError);
    setTimeout(() => {
      focus(fieldWithError);
    }, 500);
  }
}

export function scrollToElement(element: HTMLElement) {
  if (element && element.scrollIntoView) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
}

export function scrollToTop() {
  try {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  } catch(e) {
    if (window.scrollTo) {
      window.scrollTo(0, 0);
    }
  }
}

function focus(element: HTMLElement | null) {
  if (!element) return;

  if (element instanceof HTMLInputElement || element instanceof HTMLSelectElement) {
    element.focus();
  } else {
    focus(element.querySelector('input, select'));
  }
}
